
<div class="modal-dialog" style="max-width: 1000px;">
  <div class="modal-content">
    <div class="modal-header">
      <div class="w-100" *ngIf="!spreadsheet">
        <div class="col">
          <h4 class="modal-title">{{ createSelected ? 'Create ITSM Contact' : 'Select ITSM Contact' }}
            <div class="float-right" *ngIf="titleModifier"> {{titleModifier}}</div>
          </h4>
        </div>
        <button class="close" type="button" (click)="clear()">&times;</button>
      </div>
      <div class="w-100 px-4" *ngIf="spreadsheet">
        <div class="row justify-content-between">
          <h5 class="modal-title">{{ site }}</h5>
          <button class="close" type="button" (click)="clear()">&times;</button>
        </div>
        <div class="row justify-content-between mt-4">
          <h5 class="modal-title">{{ createSelected ? 'Create ' + titleModifier : titleModifier}}</h5>
          <div *ngIf="allowCreate">
            <button class="btn btn-outline-primary btn-sm px-4" *ngIf="!createSelected" type="button" [disabled]="!allowCreate" (click)="createContactEnable()">Create Contact</button>
            <button class="btn btn-outline-primary btn-sm px-4" *ngIf="createSelected" type="button" [disabled]="!allowCreate" (click)="searchContactEnable()">Select Contact</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <success></success>
      <div *ngIf="loading">
        <md-spinner-block></md-spinner-block>
      </div>
      <div *ngIf="!loading">
        <div class="m-2">
          <div class="row mb-3" *ngIf="allowCreate &amp;&amp; !spreadsheet">
            <div class="col-12">
              <div class="float-right pb-2">
                <div class="btn-group mt-2" *ngIf="!createSelected">
                  <div class="container">
                    <button class="btn btn-outline-primary" type="button" [disabled]="!allowCreate" (click)="createContactEnable()">Create Contact</button>
                  </div>
                </div>
                <div class="btn-group mt-2" *ngIf="createSelected">
                  <button class="btn btn-outline-primary" type="button" [disabled]="!allowCreate" (click)="searchContactEnable()">Select Contact</button>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="!createSelected" [ngClass]="spreadsheet ? &quot;container-fluid spreadsheet-container&quot; : &quot;container&quot;">
            <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
            <div *ngIf="spreadsheet" style="overflow-x: scroll">
              <table class="table table-bordered border-top-0 mt-4" style="width: 1150px">
                <thead>
                  <tr class="tr-header-edit-asset">
                    <th class="pl-5" width="260">Name</th>
                    <th width="325">Email Address</th>
                    <th width="156">Phone Number</th>
                    <th width="205">BP ID</th>
                    <th *ngIf="enhanceMS4Lookup == false" width="205">Locale</th>
                    <th *ngIf="enhanceMS4Lookup" width="205">Country</th>
                    <th *ngIf="enhanceMS4Lookup" width="205">Language</th>
                  </tr>
                </thead>
                <tbody style="font-size: 0.8rem">
                  <ng-container *ngIf="displayedItsmContacts">
                    <ng-container *ngFor="let contact of displayedItsmContacts; let idx = index;">
                      <tr [ngStyle]="{'font-weight': contact.id === selectedTmcContactId ? 'bold' : 'normal'}">
                        <td>
                          <input class="align-middle mr-4" type="radio" name="selectedContactRadio" ngbTooltip="Select Contact" (change)="setContact(contact.id)" [checked]="contact.id === selectedTmcContactId"><span>{{contact.firstName}} {{contact.lastName}}</span>
                        </td>
                        <td>{{contact.emailAddress}}</td>
                        <td>{{ contact.phoneNumber || contact.phoneNumber2 }}</td>
                        <td>{{contact.businessPartnerId}}</td>
                        <td *ngIf="enhanceMS4Lookup == false">{{ contactLocales[contact.locale] || contact.locale }}&nbsp;</td>
                        <td *ngIf="enhanceMS4Lookup">{{ contactCountries[contact.country] || contact.country }}&nbsp;</td>
                        <td *ngIf="enhanceMS4Lookup">{{ contactLanguages[contact.language] || contact.language }}&nbsp;</td>
                      </tr>
                    </ng-container>
                    <tr *ngIf="!displayedItsmContacts || displayedItsmContacts.length === 0">
                      <td colspan="5">
                        <p class="text-center empty-table-message">There are no contacts to display.</p>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </div>
            <table class="table table-responsive customer-table" *ngIf="!spreadsheet">
              <thead>
                <tr class="table-header-with-controls">
                  <th style="width: 70px;"></th>
                  <th style="width: 280px;">Email Address</th>
                  <th>Name</th>
                  <th style="width: 130px;">BP ID</th>
                  <th style="width: 70px;"></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="displayedItsmContacts">
                  <ng-container *ngFor="let contact of displayedItsmContacts; let idx = index;">
                    <tr [ngStyle]="{'font-weight': contact.id === selectedTmcContactId ? 'bold' : 'normal'}">
                      <td class="form-group">
                        <div class="form-check tmc-radio">
                          <input type="radio" name="selectedContactRadio" ngbTooltip="Select Contact" (change)="setContact(contact.id)" [checked]="contact.id === selectedTmcContactId">
                        </div>
                      </td>
                      <td>{{contact.emailAddress}}</td>
                      <td>{{contact.firstName}} {{contact.lastName}}</td>
                      <td>{{contact.businessPartnerId}}</td>
                      <td class="text-center"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show contact details" (click)="toggleExpandedContact(contact.id)"><span class="icon oi oi-chevron-bottom" *ngIf="expandedTmcContactId !== contact.id"></span><span class="icon oi oi-chevron-top" *ngIf="expandedTmcContactId === contact.id"></span></a></td>
                    </tr>
                    <ng-container *ngIf="expandedTmcContactId === contact.id">
                      <tr *ngIf="contactDetail.phoneNumber">
                        <td class="border-top-0"></td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div>Phone Number</div>
                          </div>
                        </td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div class="text-secondary" *ngIf="!contactDetail.phoneNumber"><i>Phone Number</i></div>
                            <div class="border-bottom text-secondary">{{contactDetail.phoneNumber}}&nbsp;</div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="contactDetail.phoneNumber2">
                        <td class="border-top-0"></td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div>Phone Number 2</div>
                          </div>
                        </td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div class="text-secondary" *ngIf="!contactDetail.phoneNumber2"><i>Phone Number 2</i></div>
                            <div class="border-bottom text-secondary">{{contactDetail.phoneNumber2}}&nbsp;</div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="enhanceMS4Lookup == false &amp;&amp; contactDetail.locale">
                        <td class="border-top-0"></td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div>Locale</div>
                          </div>
                        </td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div class="text-secondary" *ngIf="!contactDetail.locale"><i>Locale</i></div>
                            <div class="border-bottom text-secondary">{{ contactLocales[contactDetail.locale] || contactDetail.locale }}&nbsp;</div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="enhanceMS4Lookup == true">
                        <td class="border-top-0"></td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div>Country</div>
                          </div>
                        </td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div class="text-secondary" *ngIf="!contactDetail.country"><i>Country</i></div>
                            <div class="border-bottom text-secondary">{{ contactCountries[contactDetail.country] || contactDetail.country }}&nbsp;</div>
                          </div>
                        </td>
                      </tr>
                      <tr *ngIf="enhanceMS4Lookup == true">
                        <td class="border-top-0"></td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div>Language</div>
                          </div>
                        </td>
                        <td class="border-top-0">
                          <div class="form-group">
                            <div class="text-secondary" *ngIf="!contactDetail.language"><i>Language</i></div>
                            <div class="border-bottom text-secondary">{{ contactLanguages[contactDetail.language] || contactDetail.language }}&nbsp;</div>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                  </ng-container>
                  <tr *ngIf="!displayedItsmContacts || displayedItsmContacts.length === 0">
                    <td colspan="4">
                      <p class="text-center empty-table-message">There are no contacts to display.</p>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="container" *ngIf="createSelected" [ngStyle]="spreadsheet ? {&quot;font-size&quot;: &quot;0.9rem&quot;} : {}">
            <form [formGroup]="contactForm" (ngSubmit)="false">
              <div class="row">
                <div class="form-group col-6">
                  <label class="required bold">Email Address</label>
                  <input class="form-control" id="emailAddress" name="emailAddress" type="text" formControlName="emailAddress" maxLength="80" autoLinkToLabel (onChange)="checkEmailAddress(emailAddress, firstName, lastName)"><span class="d-block" *ngIf="!allowedEmailAddress" style="color: red;">{{ itsmEmailAddressWarning }}</span>
                </div>
                <div class="form-group col-6"></div>
              </div>
              <div class="row" *ngIf="requireBpId">
                <div class="form-group col-6" *ngIf="requireBpId">
                  <label class="required bold">BP ID</label>
                  <input class="form-control" id="businessPartnerId" name="businessPartnerId" type="text" formControlName="businessPartnerId" maxLength="15" autoLinkToLabel (onChange)="checkBpId(businessPartnerId)"><span class="d-block" *ngIf="!allowedBpId" style="color: red;">{{ itsmBpIdWarning }}</span>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label class="required bold">First Name</label>
                  <input class="form-control" id="firstName" name="firstName" type="text" formControlName="firstName" maxLength="40">
                </div>
                <div class="form-group col-6">
                  <label class="required bold">Last Name</label>
                  <input class="form-control" id="lastName" name="lastName" type="text" formControlName="lastName" maxLength="40">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6">
                  <label class="required bold">Phone Number 1</label>
                  <input class="form-control" id="phoneNumber" name="phoneNumber" type="text" formControlName="phoneNumber" maxLength="40">
                </div>
                <div class="form-group col-6">
                  <label class="bold">Phone Number 2</label>
                  <input class="form-control" id="phoneNumber2" name="phoneNumber2" type="text" formControlName="phoneNumber2" maxLength="40">
                </div>
              </div>
              <div class="row">
                <div class="form-group col-6" *ngIf="enhanceMS4Lookup == false">
                  <label class="required bold">Locale</label>
                  <select-contact-locale [inputId]="'contactLocale'" formControlName="locale" [inputName]="'contactLocale'"></select-contact-locale>
                </div>
                <div class="form-group col-6">
                  <label class="bold">Mail Stop<i class="text-danger">&ensp;(upload only)</i></label>
                  <input class="form-control" id="mailStop" name="mailStop" type="text" formControlName="mailStop" maxLength="40">
                </div>
              </div>
              <div class="row" *ngIf="enhanceMS4Lookup == true">
                <div class="form-group col-6">
                  <label class="required bold">Country</label>
                  <select-contact-country [inputId]="'country'" formControlName="country" [inputName]="'contactCountry'"></select-contact-country>
                </div>
                <div class="form-group col-6">
                  <label class="required bold">Language</label>
                  <select-contact-language [inputId]="'language'" formControlName="language" [inputName]="'contactLanguage'"></select-contact-language>
                </div>
              </div>
              <div class="row">
                <div class="form-group col-12">
                  <label class="bold" for="note">Note<i class="text-danger">&ensp;(upload only)</i></label>
                  <textarea class="form-control" id="note" name="note" type="text" formControlName="note" maxLength="400"></textarea>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <div>
        <button class="btn btn-outline-secondary mr-3" [ngClass]="{&quot;btn-sm px-4&quot;: spreadsheet}" type="button" title="Cancel" (click)="clear()">Cancel</button>
        <button class="btn btn-outline-primary" *ngIf="!createSelected" [ngClass]="{&quot;btn-sm px-4&quot;: spreadsheet}" type="submit" (click)="submit()">Select</button>
        <button class="btn btn-outline-primary" *ngIf="createSelected" [ngClass]="{&quot;btn-sm px-4&quot;: spreadsheet}" type="submit" (click)="createItsmContact()">Create Contact</button>
      </div>
    </div>
  </div>
</div>